import {
  ADD_COURSE,
  ADD_COURSE_SUCCESS,
  ADD_COURSE_CLEAN,
  API_ERROR,
} from "./actionTypes"

export const addCourse = form => ({
  type: ADD_COURSE,
  payload: { form },
})

export const addCourseSuccess = course => {
  return {
    type: ADD_COURSE_SUCCESS,
    payload: { course },
  }
}

export const addCourseClean = () => {
  return {
    type: ADD_COURSE_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
